import { useOutletContext } from "react-router-dom"
import { GlobalProps } from "@layout/index"

export const useAppNavigation = () => {
  const { show, jumpTo, error } = useOutletContext<GlobalProps>()

  return {
    show,
    jumpTo,
    error,
  }
}
